import { FRISBEE_RADIUS, FRISBEE_SPEED, WORLD_HEIGHT, WORLD_WIDTH } from "../game/constants";

export class Frisbee {
  x: number;
  y: number;
  vx: number;
  vy: number;
  spin = 0;
  radius = FRISBEE_RADIUS;
  alive = true;
  piercing: boolean;
  hitCount = 0;
  private wobble = Math.random() * Math.PI * 2;

  constructor(x: number, y: number, dirX: number, dirY: number, piercing: boolean) {
    const len = Math.hypot(dirX, dirY) || 1;
    this.x = x;
    this.y = y;
    this.vx = (dirX / len) * FRISBEE_SPEED;
    this.vy = (dirY / len) * FRISBEE_SPEED;
    this.piercing = piercing;
  }

  update(dt: number): void {
    if (!this.alive) return;
    this.x += this.vx * dt;
    this.y += this.vy * dt;
    this.spin += dt * 9.5;
    this.wobble += dt * 5;
  }

  get outOfBounds(): boolean {
    return this.x < -50 || this.x > WORLD_WIDTH + 50 || this.y < -50 || this.y > WORLD_HEIGHT + 50;
  }

  draw(ctx: CanvasRenderingContext2D, gold: boolean, highContrast: boolean): void {
    const tilt = Math.sin(this.wobble) * 0.06;
    ctx.save();
    ctx.translate(this.x, this.y);
    ctx.rotate(tilt);
    if (gold) {
      ctx.shadowColor = "rgba(255, 210, 60, 0.85)";
      ctx.shadowBlur = 18;
    }
    ctx.scale(1, 0.36);
    ctx.beginPath();
    ctx.arc(0, 0, this.radius + 2, 0, Math.PI * 2);
    ctx.fillStyle = gold ? "#b8860b" : highContrast ? "#7a1020" : "#9b1b2e";
    ctx.fill();
    ctx.save();
    ctx.beginPath();
    ctx.arc(0, 0, this.radius - 1, 0, Math.PI * 2);
    ctx.clip();
    const panels = 8;
    for (let i = 0; i < panels; i += 1) {
      const a0 = this.spin + (i * Math.PI * 2) / panels;
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.arc(0, 0, this.radius, a0, a0 + Math.PI / panels);
      ctx.closePath();
      if (gold) ctx.fillStyle = i % 2 === 0 ? "#ffe566" : "#fff3b0";
      else ctx.fillStyle = i % 2 === 0 ? "#ff3b3b" : "#ff6b6b";
      ctx.fill();
    }
    ctx.restore();
    ctx.beginPath();
    ctx.arc(0, 0, this.radius - 1, 0, Math.PI * 2);
    ctx.strokeStyle = gold ? "#fff3b0" : highContrast ? "#111" : "rgba(255,255,255,0.45)";
    ctx.lineWidth = 2;
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(0, 0, 5, 0, Math.PI * 2);
    ctx.fillStyle = gold ? "#fff8dc" : "#fff";
    ctx.fill();
    ctx.fillStyle = "rgba(255,255,255,0.35)";
    ctx.beginPath();
    ctx.ellipse(-this.radius * 0.25, -this.radius * 0.35, this.radius * 0.35, this.radius * 0.18, -0.4, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }
}
